module.exports = __webpack_public_path__ + "img/no-terms.f3bfb14e.svg";